import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { setAnsweringInfoAction } from "../../../../redux/answeringQuestions/answeringInfo";

const AccuracyLabelChanger = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const answeringInfo = useSelector( state => state.answeringInfo );

  const dispatch = useDispatch();
  const setAnsweringInfo = payload => { dispatch( setAnsweringInfoAction( payload ) ) };

  const { t } = useTranslation();

  useEffect( () => {
    if ( answeringQuestions.data.accuracy ) {
      switch ( answeringInfo.accuracyLevel ) {
        case 0 :
          if ( 50 <= answeringQuestions.data.accuracy && 70 > answeringQuestions.data.accuracy ) {
            setAnsweringInfo( {
              accuracyLevel : 1,
              accuracyMessage : t( 'LC_02_06.msg003' )
            } );
          }
          break;
        case 1 :
          if ( 70 <= answeringQuestions.data.accuracy && 90 > answeringQuestions.data.accuracy ) {
            setAnsweringInfo( {
              accuracyLevel : 2,
              accuracyMessage : t( 'LC_02_06.msg004' )
            } );
          }
          break;
        case 2 :
          if ( 90 <= answeringQuestions.data.accuracy && 100 >= answeringQuestions.data.accuracy ) {
            setAnsweringInfo( {
              accuracyLevel : 3,
              accuracyMessage : t( 'LC_02_06.msg005' )
            } );
          }
          break;
      }
      const timer = setTimeout( () => { setAnsweringInfo( { accuracyMessage : '' } ) }, 3000 );
      return () => {
        clearTimeout( timer );
      };
    }
  }, [ answeringQuestions.data.accuracy ] );

  return props.children || null;

};

export default AccuracyLabelChanger;
